import { isDevelopment } from "shared/lib/utils/env";
import { VaultNameOptionMap, } from "shared/lib/constants/constants";
import ProofKovanData from "../data/proof-kovan.json";
import ProofData from "../data/proof.json";
import AirdropKovanData from "../data/airdrop-kovan.json";
import AirdropData from "../data/airdrop.json";
import BreakdownKovanData from "../data/breakdown-kovan.json";
import BreakdownData from "../data/breakdown.json";
import moment from "moment";
export var proof = isDevelopment() ? ProofKovanData : ProofData;
export var airdrop = isDevelopment()
    ? AirdropKovanData
    : AirdropData;
export var breakdown = isDevelopment()
    ? BreakdownKovanData
    : BreakdownData;
export var getVaultURI = function (vaultOption, vaultVersion) {
    if (vaultVersion === void 0) { vaultVersion = "v1"; }
    switch (vaultVersion) {
        case "v1":
            return "/theta-vault/" + Object.keys(VaultNameOptionMap)[Object.values(VaultNameOptionMap).indexOf(vaultOption)];
        case "v2":
            return "/v2/theta-vault/" + Object.keys(VaultNameOptionMap)[Object.values(VaultNameOptionMap).indexOf(vaultOption)];
        case "earn":
            return "/earn/" + Object.keys(VaultNameOptionMap)[Object.values(VaultNameOptionMap).indexOf(vaultOption)];
    }
};
var vaultFirstStrategyTime = function (vaultOption) {
    switch (vaultOption) {
        case "rEARN":
            return moment.utc("2022-09-02").set("hour", 17);
        case "rEARN-stETH":
            return moment.utc("2022-12-09").set("hour", 17);
        default:
            return moment();
    }
};
export var useEarnStrategyTime = function (vaultOption) {
    var firstOpenLoanTime = vaultFirstStrategyTime(vaultOption);
    var strategyStartTime;
    while (!strategyStartTime) {
        var strategyStartTimeTemp = moment.duration(firstOpenLoanTime.diff(moment()), "milliseconds");
        if (strategyStartTimeTemp.asMilliseconds() <= 0) {
            firstOpenLoanTime.add(7, "days");
        }
        else {
            strategyStartTime = strategyStartTimeTemp;
        }
    }
    return {
        strategyStartTime: strategyStartTime.days() + "D " + strategyStartTime.hours() + "H " + strategyStartTime.minutes() + "M",
        withdrawalDate: firstOpenLoanTime.format("Do MMM, YYYY"),
        depositWithdrawalDate: firstOpenLoanTime
            .add(7, "days")
            .format("Do MMM, YYYY"),
    };
};
//# sourceMappingURL=constants.js.map